"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function StatusIcon(props) {
  var style = props.size ? {
    height: props.size * 0.7,
    width: props.size
  } : {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "symbol symbol-status-".concat(props.status),
    style: style
  });
}

StatusIcon.propTypes = {
  status: _propTypes.default.oneOf(['check', 'cross', 'clock', 'warning', 'not-applicable']),
  size: _propTypes.default.number
};
var _default = StatusIcon;
exports.default = _default;
//# sourceMappingURL=StatusIcon.js.map